export const AKAMAI_IMAGE_URL = "https://adn-static1.nykaa.com/nykdesignstudio-images";
export const IMAGE_KIT_URL = "https://images-static.nykaa.com";
export const FAVICON =
    "https://adn-static1.nykaa.com/nykdesignstudio-images/pub/media/favicon/stores/1/nds_-_favicon.png";
export const DEFAULT_TITLE =
    "Shop Designer Clothes &amp; Accessories Online from Top Indian Designers | Nykaa Fashion";

export enum RENDER_MODE {
    MOBILE,
    DESKTOP,
}

export const SLIDE_DIRECTIONS = {
    PREV: "PREV",
    NEXT: "NEXT",
};

export const CAROUSEL_DIRECTION = {
    HORIZONTAL: "HORIZONTAL",
    VERTICAL: "VERTICAL",
};
export const DEFAULT_CURRENCY = "₹";
export const DEFAULT_COUNTRY = "IN";

export const IMAGE_WIDTH_MOBILE = 412;
export const IMAGE_WIDTH_DESKTOP = 503;

export const API_CACHE_TTL = Number(process.env.API_CACHE_TTL) * 60 * 1000;

export enum APP_CONTEXT {
    WEB = "web",
    ANDROID = "android",
    IOS = "ios",
}
